import React, { useMemo, useRef, useState } from 'react'
import { Select, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

import { ReactComponent as SelectArrow } from '../../../svg/node/select-arrow.svg'

import styles from './Nodes.module.css'

const defaultFilter = (input, option) => {
  const q = String(input ?? '').trim().toLowerCase()
  if (!q) return true
  return String(option?.label ?? '').toLowerCase().includes(q)
}

function DropdownSearch({ menu, query, onQueryChange, inputRef }) {
  return (
    <div onMouseDown={(e) => e.preventDefault()} className={styles.nodeSelectDropdownRoot}>
      <div className={styles.nodeSelectDropdownSearch}>
        <Input
          ref={inputRef}
          className={styles.nodeSelectDropdownInput}
          allowClear
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search"
          prefix={<SearchOutlined className={styles.nodeSelectDropdownSearchPrefix} />}
        />
      </div>
      {menu}
    </div>
  )
}

export const NodeSelect = ({
  options,
  className = '',
  defaultValue,
  onChange,
  disabled,
  showSearch,
  filterOption,
  filterSort,
  virtual,
  ...rest
}) => {
  const [query, setQuery] = useState('')
  const inputRef = useRef(null)
  const { dropdownRender: parentDropdownRender, onDropdownVisibleChange, ...selectRest } = rest

  const filteredOptions = useMemo(() => {
    if (!showSearch) return options
    const q = query.trim()
    if (!q) return options
    const filterFn = typeof filterOption === 'function' ? filterOption : defaultFilter
    return options.filter((opt) => filterFn(q, opt))
  }, [options, showSearch, query, filterOption])

  const handleOpenChange = (open) => {
    onDropdownVisibleChange?.(open)
    if (showSearch && !open) setQuery('')
    if (showSearch && open) {
      window.setTimeout(() => inputRef.current?.focus?.({ preventScroll: true }), 350)
    }
  }

  const dropdownRender = showSearch
    ? (menu) => (
        <DropdownSearch
          menu={menu}
          query={query}
          onQueryChange={setQuery}
          inputRef={inputRef}
        />
      )
    : parentDropdownRender

  return (
    <div className={`${styles.nodeSelectWrapper} nodrag`}>
      <Select
        {...selectRest}
        className={className}
        value={defaultValue}
        onChange={onChange}
        disabled={disabled}
        options={filteredOptions}
        showSearch={false}
        filterSort={showSearch ? undefined : filterSort}
        virtual={virtual}
        dropdownRender={dropdownRender}
        onDropdownVisibleChange={handleOpenChange}
        suffixIcon={<SelectArrow />}
      />
    </div>
  )
}
